export enum ViewQueryParam {
  ViewId = 'viewId',
}
